/* eslint-disable react/prop-types */
import React, { Component, createRef } from "react";
import { Table, Form, Popup, Button, Grid, Segment, Icon } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { read, write } from "xlsx";
import { logAction } from "../actions/changeActiveItemActions";
import Constants from "./utilities/Constants";
import Strings from "./utilities/StringSelector";
import Utils from "./utilities/Utils";

const statusKeyArray = [
  Strings.OK_STRING,
  Strings.DIAGNOSTIC_STRING,
  Strings.ONLINE_STRING,
  Strings.FAULT_STRING,
  Strings.CONFIG_ERROR_STRING,
  Strings.MASTER_FAULT_STRING,
  Strings.PARAM_ERROR_STRING,
  Strings.CRITIC_SLAVE_STRING,
  Strings.BLACKLIST_STRING,
  Strings.MASTER_FAULT_STRING,
  Strings.SLAVE_MASTER_FAULT_STRING,
  Strings.MISSING_SINGULAR_STRING,
  Strings.MPI_STRING,
  Strings.MPI_STRING
];

const statusValueArray = [
  "ok",
  "diagnostic",
  "online",
  "fault",
  "errorConfig",
  "master",
  "errorParam",
  "critical",
  "blacklist",
  "masterFault",
  "slaveMasterFault",
  "missing",
  "mpi",
  "mpiFault"
];

const UtilsInstance = new Utils();
var cameFromHomepageListClick = false;

class LiveList extends Component {
  contextReference = createRef();

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      formInput: "",
      column: null,
      sortDirection: "ascending",
      originalDevices: [],
      devices: [],
      isColumnClicked: false,
      isStatusCellClicked: false,
      clickedDevice: "",
      clickedMac: "",
      maintenance: []
    };
    cameFromHomepageListClick = false;
  }

  addAditionalInfoToDevices = () => {
    let devicesCopy = this.state.devices;
    let originalDevicesCopy = this.state.originalDevices;

    for (let i = 0; i < devicesCopy.length; i++) {

      devicesCopy[i].availability = this.getDeviceAvailability(devicesCopy[i]);

      if (devicesCopy[i].isInBlacklist) {
        devicesCopy[i].severity = 1;
      }
      else if (devicesCopy[i].isInAutomaticBlacklist) {
        devicesCopy[i].severity = 6;
      }
      else {
        if (devicesCopy[i].status === Constants.ONLINE) {
          devicesCopy[i].severity = 0;
        } else if (devicesCopy[i].status === Constants.OK) {
          devicesCopy[i].severity = 2;
        } else if (devicesCopy[i].status === Constants.DIAGNOSTIC) {
          devicesCopy[i].severity = 3;
        } else if (devicesCopy[i].status === Constants.PARAM_ERROR) {
          devicesCopy[i].severity = 4;
        } else if (devicesCopy[i].status === Constants.CONFIG_ERROR) {
          devicesCopy[i].severity = 5;
        } else if (devicesCopy[i].status === Constants.FAULT) {
          devicesCopy[i].severity = 7;
        } else if (devicesCopy[i].status === Constants.MPI) {
          devicesCopy[i].severity = 8;
        } else if (devicesCopy[i].status === Constants.MASTER) {
          devicesCopy[i].severity = 9;
        } else if (devicesCopy[i].status === Constants.MPI_FAULT) {
          devicesCopy[i].severity = 10;
        } else if (devicesCopy[i].status === Constants.SLAVE_MASTER_FAULT) {
          devicesCopy[i].severity = 11;
        } else if (devicesCopy[i].status === Constants.MASTER_FAULT) {
          devicesCopy[i].severity = 12;
        } else if (devicesCopy[i].status === Constants.MISSING) {
          devicesCopy[i].severity = -1;
        }
      }
    }

    for (let i = 0; i < originalDevicesCopy.length; i++) {

      originalDevicesCopy[i].availability = this.getDeviceAvailability(originalDevicesCopy[i]);

      if (originalDevicesCopy[i].isInBlacklist) {
        originalDevicesCopy[i].severity = 1;
      }
      else if (originalDevicesCopy[i].isInAutomaticBlacklist) {
        originalDevicesCopy[i].severity = 6;
      }
      else {
        if (originalDevicesCopy[i].status === Constants.ONLINE) {
          originalDevicesCopy[i].severity = 0;
        } else if (originalDevicesCopy[i].status === Constants.OK) {
          originalDevicesCopy[i].severity = 2;
        } else if (originalDevicesCopy[i].status === Constants.DIAGNOSTIC) {
          originalDevicesCopy[i].severity = 3;
        } else if (originalDevicesCopy[i].status === Constants.PARAM_ERROR) {
          originalDevicesCopy[i].severity = 4;
        } else if (originalDevicesCopy[i].status === Constants.CONFIG_ERROR) {
          originalDevicesCopy[i].severity = 5;
        } else if (originalDevicesCopy[i].status === Constants.FAULT) {
          originalDevicesCopy[i].severity = 7;
        } else if (devicesCopy[i].status === Constants.MPI) {
          devicesCopy[i].severity = 8;
        } else if (devicesCopy[i].status === Constants.MASTER) {
          devicesCopy[i].severity = 9;
        } else if (devicesCopy[i].status === Constants.MPI_FAULT) {
          devicesCopy[i].severity = 10;
        } else if (devicesCopy[i].status === Constants.SLAVE_MASTER_FAULT) {
          devicesCopy[i].severity = 11;
        } else if (devicesCopy[i].status === Constants.MASTER_FAULT) {
          devicesCopy[i].severity = 12;
        } else if (devicesCopy[i].status === Constants.MISSING) {
          devicesCopy[i].severity = -1;
        }
      }
    }

    this.setState({
      devices: devicesCopy.sort(UtilsInstance.sortBy(
        "address",
        false,
        parseInt)),
      originalDevices: originalDevicesCopy.sort(UtilsInstance.sortBy(
        "address",
        false,
        parseInt))
    });
  }

  // Creates a list with an entry that matches the address received from 
  // a click on the supervisor's last event button
  handleSupervisorAddressSearch = () => {
    if (this.props.match.params.address !== undefined
      && this.props.match.params.address !== null
      && this.props.match.params.address !== -1) {
      let addressToSearch = this.props.match.params.address;

      // Here we reuse the Homepage last click variable because the context is similar
      // and the behavior of the filtering is the same
      cameFromHomepageListClick = true;
      const len = this.state.originalDevices.length;
      const searchedDevices = [];

      for (let i = 0; i < len; i++) {
        if (this.state.originalDevices[i].address.toString() === addressToSearch.toString()) {
          searchedDevices.push(this.state.originalDevices[i]);
        }
      }

      // Erase the address, so the page behaves normaly after filtering once
      this.props.match.params.address = -1;

      // Show all devices that matched the address or none
      if (searchedDevices.length > 0) {
        this.setState({ devices: searchedDevices });
      } else {
        this.setState({ devices: [] });
      }
    }
  }

  // Creates a list with an entry that matches the address received from 
  // a click on the homepage network status list
  handleNetworkStatusAddressSearch = () => {
    if (this.props.location.state !== undefined) {
      if (this.props.location.state.address !== undefined) {
        if (this.props.location.state.address === -1) {
          this.setState({ devices: this.state.originalDevices });
        }
        else {
          cameFromHomepageListClick = true;
          const len = this.state.originalDevices.length;
          const searchedDevices = [];

          for (let i = 0; i < len; i++) {
            if (this.state.originalDevices[i].address.toString() === this.props.location.state.address.toString()) {
              searchedDevices.push(this.state.originalDevices[i]);
            }
          }
          // Show all devices that matched the address or none
          if (searchedDevices.length > 0) {
            this.setState({ devices: searchedDevices });
          } else {
            this.setState({ devices: [] });
          }
        }
      }
    }
  }

  // Creates a list with an entry that matches the address received from 
  // a click on the homepage retries list
  handleRetriesAddressSearch = () => {
    if (this.props.location.state !== undefined) {
      if (this.props.location.state.addressList !== undefined) {

        cameFromHomepageListClick = true;
        const originalDevicesLen = this.state.originalDevices.length;
        const filterDevicesLen = this.props.location.state.addressList.length;

        const searchedDevices = [];

        for (let i = 0; i < originalDevicesLen; i++) {
          for (let j = 0; j < filterDevicesLen; j++) {
            if (this.props.location.state.addressList[j].toString() === this.state.originalDevices[i].address.toString()) {
              searchedDevices.push(this.state.originalDevices[i]);
            }
          }
        }
        // Show all devices that matched the address or none
        if (searchedDevices.length > 0) {
          this.setState({ devices: searchedDevices });
        } else {
          this.setState({ devices: [] });
        }
      }
    }
  }

  // Sorts the table when the user clicks on one of the columns
  handleSort = (clickedColumn) => () => {

    this.setState({
      isColumnClicked: true
    });

    // The user wants to order the live list by address ascending
    if (clickedColumn === "address" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "address",
            false,
            parseInt)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by address descending
    else if (clickedColumn === "address" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "address",
            true,
            parseInt)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by tag ascending
    else if (clickedColumn === "tag" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "tag",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by tag descending
    else if (clickedColumn === "tag" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "tag",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by model ascending
    else if (clickedColumn === "model" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "model",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by model descending
    else if (clickedColumn === "model" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "model",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by diagnostics ascending
    else if (clickedColumn === "diagnostics" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "diagnostics",
            false,
            parseInt)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by diagnostics descending
    else if (clickedColumn === "diagnostics" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "diagnostics",
            true,
            parseInt)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by retries ascending
    else if (clickedColumn === "retries" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "retries",
            false,
            parseInt)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by retries descending
    else if (clickedColumn === "retries" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "retries",
            true,
            parseInt)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by retries ascending
    else if (clickedColumn === "retriesNoFault" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "retriesNoFault",
            false,
            parseInt)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by retries descending
    else if (clickedColumn === "retriesNoFault" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "retriesNoFault",
            true,
            parseInt)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by faults ascending
    else if (clickedColumn === "faults" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "faults",
            false,
            parseInt)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by faults descending
    else if (clickedColumn === "faults" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "faults",
            true,
            parseInt)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by status ascending
    else if (clickedColumn === "status" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "severity",
            false,
            parseInt)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by status descending
    else if (clickedColumn === "status" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "severity",
            true,
            parseInt)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by availability ascending
    else if (clickedColumn === "availability" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "availability",
            false,
            parseInt)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by availability descending
    else if (clickedColumn === "availability" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "availability",
            true,
            parseInt)),
        sortDirection: "ascending",
      });
    }
  }

  // Creates a list with entries that match the address passed on the form
  handleAddressSearch = () => {
    const len = this.state.originalDevices.length;
    const searchedDevices = [];
    for (let i = 0; i < len; i++) {
      if (this.state.originalDevices[i].address === parseInt(this.state.formInput)) {
        searchedDevices.push(this.state.originalDevices[i]);
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  // Creates a list with entries that match the status passed on the form
  handleStatusSearch = (statusArray) => {
    const len = this.state.originalDevices.length;
    const searchedDevices = [];

    for (let i = 0; i < statusArray.length; i++) {
      if (statusArray[i] === Constants.CRITICAL) {
        for (let j = 0; j < len; j++) {
          if (this.state.originalDevices[j].isInAutomaticBlacklist) {
            searchedDevices.push(this.state.originalDevices[j]);
          }
        }
      }
      else if (statusArray[i] === Constants.BLACKLIST) {
        for (let j = 0; j < len; j++) {
          if (this.state.originalDevices[j].isInBlacklist) {
            searchedDevices.push(this.state.originalDevices[j]);
          }
        }
      }
      else {
        for (let j = 0; j < len; j++) {
          if (this.state.originalDevices[j].status === statusArray[i]) {
            searchedDevices.push(this.state.originalDevices[j]);
          }
        }
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  /*
    If the user clicks on the table cell of a device a verification starts:
    If that device status is OK, Alarm, Duplicated or Online he is sent to the log page filtering all events by the address of the device
    If that device status is Offline or Fault he is asked to delete the device or be sent to the log list
    If that device status is different from any of the above (not expected) he is sent to the log list too
  */
  handleStatusCellClick = (address) => () => {
    this.props.onChangeLog();
    this.props.history.push({
      pathname: "/log",
      state: { deviceAddress: address }
    });
  }

  /*
    If the user typed a substring of one of the possible status: (In uppercase, lowercase or a mix of them)
    it returns and array containing the indexes to match against the json received from the server
  */
  matchFormInputStatus = () => {
    const len = statusKeyArray.length;
    let matchedArray = [-1];
    let matchedIndex = 0;

    for (let i = 0; i < len; i++) {
      // Uppercases the user input before comparison to allow for a more flexible search
      // It doesn't matter if the user typed in uppercase, lowercase or any combination of them
      const status = statusKeyArray[i].toUpperCase();
      const upperCaseUserInput = this.state.formInput.toUpperCase();
      if (status.indexOf(upperCaseUserInput) !== -1) {
        matchedArray[matchedIndex] = i;
        matchedIndex++;
      }
    }

    return matchedArray;
  }

  /*
    Filters the page list showing only the devices that match the address or status typed in the form
  */
  handleSubmit = () => {
    cameFromHomepageListClick = false;
    const matchValueArray = this.matchFormInputStatus();
    let auxArray = [];

    for (let i = 0; i < matchValueArray.length; i++) {
      auxArray.push(statusValueArray[matchValueArray[i]]);
    }

    if (this.state.formInput !== "" && matchValueArray[0] !== -1) {
      this.handleStatusSearch(auxArray);
    }
    else if (this.state.formInput === "") {
      this.setState({ devices: this.state.originalDevices });
    }
    // If what the user typed is not a status and the form is not blank, try to see if he typed a number
    else {
      this.handleAddressSearch();
    }
  }

  retrieveData = () => {
    // Retrieve devices list only if the input form is empty and the user didn't come from
    // a NetworkStatus click and the user didn't sort the table by clicking a column header
    if (this.state.formInput === "" && !cameFromHomepageListClick && !this.state.isColumnClicked) {
      // Get the maintenance data to calculate the avaiability
      fetch(Constants.REQUEST_IP_ADDRESS + "maintenance", { mode: "cors" })
        .then(res => res.json())
        .then(data => this.setState({
          maintenance: data.sort(UtilsInstance.sortBy(
            "address",
            false,
            parseInt))
        }, () => {
          // then get the live list data itself
          fetch(Constants.REQUEST_IP_ADDRESS, { mode: "cors" })
            .then(res => res.json())
            .then(data => this.setState({
              devices: data,
              originalDevices: data
            }, () => {
              this.addAditionalInfoToDevices();
              this.handleNetworkStatusAddressSearch();
              this.handleRetriesAddressSearch();
              this.handleSupervisorAddressSearch();
            }));
        }));
    }
  }

  getDeviceTooltip = (device) => {
    if (device.lastEvent.length === 1) {
      let lastEventString = Strings.LAST_EVENT;
      lastEventString = lastEventString.concat(device.lastEvent[0]);
      return lastEventString;
    }
    else {
      if (device.lastEvent.length >= 4) {
        let lastEventString = Strings.LAST_EVENT + Strings.LAST_EVENT_TOO_BIG_STRING;
        return lastEventString;
      }
      else {
        let listItems = device.lastEvent.map((event) => (
          <li key={Math.random()}>{event}</li>
        ));

        return (
          <div>
            <p>{Strings.LAST_EVENT}</p>
            <ul>
              <li>{listItems}</li>
            </ul>
          </div>
        );
      }
    }
  }

  /* 
    Create Status Cell
    parameters: 
    - device: JSON information of the device being added to the table
    - return: A new table cell stylized according to the current device status
  */
  createStatusCell = (device) => {
    if (device.isInBlacklist) {
      if (device.lastEvent === null) {
        return (
          <Table.Cell
            selectable
            width={9}
            style={blacklistCellStyle}
            onClick={this.handleStatusCellClick(device.address, device.status)}>
            {Strings.BLACKLIST_STRING}
          </Table.Cell>
        );
      }
      else {
        if (this.state.devices[this.state.devices.length - 1].address === device.address) {
          return (
            <Popup position='left center' hoverable pinned
              trigger={
                <Table.Cell
                  selectable
                  width={9}
                  style={blacklistCellStyle}
                  onClick={this.handleStatusCellClick(device.address, device.status)}>
                  {Strings.BLACKLIST_STRING}
                </Table.Cell>}>
              <Popup.Content>
                {this.getDeviceTooltip(device)}
              </Popup.Content>
            </Popup >
          );
        }
        else {
          return (
            <Popup position='bottom center' hoverable pinned
              trigger={
                <Table.Cell
                  selectable
                  width={9}
                  style={blacklistCellStyle}
                  onClick={this.handleStatusCellClick(device.address, device.status)}>
                  {Strings.BLACKLIST_STRING}
                </Table.Cell>}>
              <Popup.Content>
                {this.getDeviceTooltip(device)}
              </Popup.Content>
            </Popup >
          );
        }
      }
    }
    else if (device.isInAutomaticBlacklist) {
      if (device.lastEvent === null) {
        return (
          <Table.Cell
            selectable
            width={9}
            style={criticSlaveCellStyle}
            onClick={this.handleStatusCellClick(device.address, device.status)}>
            {Strings.CRITIC_SLAVE_STRING}
          </Table.Cell>
        );
      }
      else {
        if (this.state.devices[this.state.devices.length - 1].address === device.address) {
          return (
            <Popup position='left center' hoverable pinned
              trigger={
                <Table.Cell
                  selectable
                  width={9}
                  style={criticSlaveCellStyle}
                  onClick={this.handleStatusCellClick(device.address, device.status)}>
                  {Strings.CRITIC_SLAVE_STRING}
                </Table.Cell>}>
              <Popup.Content>
                {this.getDeviceTooltip(device)}
              </Popup.Content>
            </Popup >
          );
        }
        else {
          return (
            <Popup position='bottom center' hoverable pinned
              trigger={
                <Table.Cell
                  selectable
                  width={9}
                  style={criticSlaveCellStyle}
                  onClick={this.handleStatusCellClick(device.address, device.status)}>
                  {Strings.CRITIC_SLAVE_STRING}
                </Table.Cell>}>
              <Popup.Content>
                {this.getDeviceTooltip(device)}
              </Popup.Content>
            </Popup >
          );
        }
      }
    }
    else {
      if (device.status === Constants.OK) {
        if (device.lastEvent === null) {
          return (
            <Table.Cell
              selectable
              width={9}
              style={okCellStyle}
              onClick={this.handleStatusCellClick(device.address, device.status)}>
              {Strings.OK_STRING}
            </Table.Cell>
          );
        }
        else {
          if (this.state.devices[this.state.devices.length - 1].address === device.address) {
            return (
              <Popup position='left center' hoverable pinned
                trigger={
                  <Table.Cell
                    selectable
                    width={9}
                    style={okCellStyle}
                    onClick={this.handleStatusCellClick(device.address, device.status)}>
                    {Strings.OK_STRING}
                  </Table.Cell>}>
                <Popup.Content>
                  {this.getDeviceTooltip(device)}
                </Popup.Content>
              </Popup >
            );
          }
          else {
            return (
              <Popup position='bottom center' hoverable pinned
                trigger={
                  <Table.Cell
                    selectable
                    width={9}
                    style={okCellStyle}
                    onClick={this.handleStatusCellClick(device.address, device.status)}>
                    {Strings.OK_STRING}
                  </Table.Cell>}>
                <Popup.Content>
                  {this.getDeviceTooltip(device)}
                </Popup.Content>
              </Popup >
            );
          }
        }
      }
      else if (device.status === Constants.DIAGNOSTIC) {
        if (device.lastEvent === null) {
          return (
            <Table.Cell
              selectable
              width={9}
              style={diagnosticCellStyle}
              onClick={this.handleStatusCellClick(device.address, device.status)}>
              {Strings.DIAGNOSTIC_STRING}
            </Table.Cell>
          );
        }
        else {
          if (this.state.devices[this.state.devices.length - 1].address === device.address) {
            return (
              <Popup position='left center' hoverable pinned
                trigger={
                  <Table.Cell
                    selectable
                    width={9}
                    style={diagnosticCellStyle}
                    onClick={this.handleStatusCellClick(device.address, device.status)}>
                    {Strings.DIAGNOSTIC_STRING}
                  </Table.Cell>}>
                <Popup.Content>
                  {this.getDeviceTooltip(device)}
                </Popup.Content>
              </Popup >
            );
          }
          else {
            return (
              <Popup position='bottom center' hoverable pinned
                trigger={
                  <Table.Cell
                    selectable
                    width={9}
                    style={diagnosticCellStyle}
                    onClick={this.handleStatusCellClick(device.address, device.status)}>
                    {Strings.DIAGNOSTIC_STRING}
                  </Table.Cell>}>
                <Popup.Content>
                  {this.getDeviceTooltip(device)}
                </Popup.Content>
              </Popup >
            );
          }
        }
      }
      else if (device.status === Constants.ONLINE) {
        if (device.lastEvent === null) {
          return (
            <Table.Cell
              selectable
              width={9}
              style={onlineCellStyle}
              onClick={this.handleStatusCellClick(device.address, device.status)}>
              {Strings.ONLINE_STRING}
            </Table.Cell>
          );
        }
        else {
          if (this.state.devices[this.state.devices.length - 1].address === device.address) {
            return (
              <Popup position='left center' hoverable pinned
                trigger={
                  <Table.Cell
                    selectable
                    width={9}
                    style={onlineCellStyle}
                    onClick={this.handleStatusCellClick(device.address, device.status)}>
                    {Strings.ONLINE_STRING}
                  </Table.Cell>}>
                <Popup.Content>
                  {this.getDeviceTooltip(device)}
                </Popup.Content>
              </Popup >
            );
          }
          else {
            return (
              <Popup position='bottom center' hoverable pinned
                trigger={
                  <Table.Cell
                    selectable
                    width={9}
                    style={onlineCellStyle}
                    onClick={this.handleStatusCellClick(device.address, device.status)}>
                    {Strings.ONLINE_STRING}
                  </Table.Cell>}>
                <Popup.Content>
                  {this.getDeviceTooltip(device)}
                </Popup.Content>
              </Popup >
            );
          }
        }
      }
      else if (device.status === Constants.FAULT) {
        if (device.lastEvent === null) {
          return (
            <Table.Cell
              selectable
              width={9}
              style={faultCellStyle}
              onClick={this.handleStatusCellClick(device.address, device.status)}>
              {Strings.FAULT_STRING}
            </Table.Cell>
          );
        }
        else {
          if (this.state.devices[this.state.devices.length - 1].address === device.address) {
            return (
              <Popup position='left center' hoverable pinned
                trigger={
                  <Table.Cell
                    selectable
                    width={9}
                    style={faultCellStyle}
                    onClick={this.handleStatusCellClick(device.address, device.status)}>
                    {Strings.FAULT_STRING}
                  </Table.Cell>}>
                <Popup.Content>
                  {this.getDeviceTooltip(device)}
                </Popup.Content>
              </Popup>
            );
          }
          else {
            return (
              <Popup position='bottom center' hoverable pinned
                trigger={
                  <Table.Cell
                    selectable
                    width={9}
                    style={faultCellStyle}
                    onClick={this.handleStatusCellClick(device.address, device.status)}>
                    {Strings.FAULT_STRING}
                  </Table.Cell>}>
                <Popup.Content>
                  {this.getDeviceTooltip(device)}
                </Popup.Content>
              </Popup>
            );
          }
        }
      }
      else if (device.status === Constants.CONFIG_ERROR) {
        if (device.lastEvent === null) {
          return (
            <Table.Cell
              selectable
              width={9}
              style={configErrorCellStyle}
              onClick={this.handleStatusCellClick(device.address, device.status)}>
              {Strings.CONFIG_ERROR_STRING}
            </Table.Cell>
          );
        }
        else {
          if (this.state.devices[this.state.devices.length - 1].address === device.address) {
            return (
              <Popup position='left center' hoverable pinned
                trigger={
                  <Table.Cell
                    selectable
                    width={9}
                    style={configErrorCellStyle}
                    onClick={this.handleStatusCellClick(device.address, device.status)}>
                    {Strings.CONFIG_ERROR_STRING}
                  </Table.Cell>}>
                <Popup.Content>
                  {this.getDeviceTooltip(device)}
                </Popup.Content>
              </Popup>
            );
          }
          else {
            return (
              <Popup position='bottom center' hoverable pinned
                trigger={
                  <Table.Cell
                    selectable
                    width={9}
                    style={configErrorCellStyle}
                    onClick={this.handleStatusCellClick(device.address, device.status)}>
                    {Strings.CONFIG_ERROR_STRING}
                  </Table.Cell>}>
                <Popup.Content>
                  {this.getDeviceTooltip(device)}
                </Popup.Content>
              </Popup>
            );
          }
        }
      }
      else if (device.status === Constants.PARAM_ERROR) {
        if (device.lastEvent === null) {
          return (
            <Table.Cell
              selectable
              width={9}
              style={paramErrorCellStyle}
              onClick={this.handleStatusCellClick(device.address, device.status)}>
              {Strings.PARAM_ERROR_STRING}
            </Table.Cell>
          );
        }
        else {
          if (this.state.devices[this.state.devices.length - 1].address === device.address) {
            return (
              <Popup position='left center' hoverable pinned
                trigger={
                  <Table.Cell
                    selectable
                    width={9}
                    style={paramErrorCellStyle}
                    onClick={this.handleStatusCellClick(device.address, device.status)}>
                    {Strings.PARAM_ERROR_STRING}
                  </Table.Cell>}>
                <Popup.Content>
                  {this.getDeviceTooltip(device)}
                </Popup.Content>
              </Popup>
            );
          }
          else {
            return (
              <Popup position='bottom center' hoverable pinned
                trigger={
                  <Table.Cell
                    selectable
                    width={9}
                    style={paramErrorCellStyle}
                    onClick={this.handleStatusCellClick(device.address, device.status)}>
                    {Strings.PARAM_ERROR_STRING}
                  </Table.Cell>}>
                <Popup.Content>
                  {this.getDeviceTooltip(device)}
                </Popup.Content>
              </Popup>
            );
          }
        }
      }
      else if (device.status === Constants.MASTER) {
        if (device.lastEvent === null) {
          if (device.masterStatus !== null) {
            return (
              <Table.Cell
                selectable
                width={9}
                style={masterCellStyle}
                onClick={this.handleStatusCellClick(device.address, device.status)}>
                {Strings.MASTER_FAULT_STRING} {UtilsInstance.getMasterStatusText(device.masterStatus)}
              </Table.Cell>
            );
          }
          else {
            return (
              <Table.Cell
                selectable
                width={9}
                style={masterCellStyle}
                onClick={this.handleStatusCellClick(device.address, device.status)}>
                {Strings.MASTER_CLASS_2}
              </Table.Cell>
            );
          }
        }
        else {
          if (device.masterStatus !== null) {
            if (this.state.devices[this.state.devices.length - 1].address === device.address) {
              return (
                <Popup position='left center' hoverable pinned
                  trigger={
                    <Table.Cell
                      selectable
                      width={9}
                      style={masterCellStyle}
                      onClick={this.handleStatusCellClick(device.address, device.status)}>
                      {Strings.MASTER_FAULT_STRING} {UtilsInstance.getMasterStatusText(device.masterStatus)}
                    </Table.Cell>}>
                  <Popup.Content>
                    {this.getDeviceTooltip(device)}
                  </Popup.Content>
                </Popup>
              );
            }
            else {
              return (
                <Popup position='bottom center' hoverable pinned
                  trigger={
                    <Table.Cell
                      selectable
                      width={9}
                      style={masterCellStyle}
                      onClick={this.handleStatusCellClick(device.address, device.status)}>
                      {Strings.MASTER_FAULT_STRING} {UtilsInstance.getMasterStatusText(device.masterStatus)}
                    </Table.Cell>}>
                  <Popup.Content>
                    {this.getDeviceTooltip(device)}
                  </Popup.Content>
                </Popup>
              );
            }
          }
          else {
            if (this.state.devices[this.state.devices.length - 1].address === device.address) {
              return (
                <Popup position='left center' hoverable pinned
                  trigger={
                    <Table.Cell
                      selectable
                      width={9}
                      style={masterCellStyle}
                      onClick={this.handleStatusCellClick(device.address, device.status)}>
                      {Strings.MASTER_CLASS_2}
                    </Table.Cell>}>
                  <Popup.Content>
                    {this.getDeviceTooltip(device)}
                  </Popup.Content>
                </Popup>
              );
            }
            else {
              return (
                <Popup position='bottom center' hoverable pinned
                  trigger={
                    <Table.Cell
                      selectable
                      width={9}
                      style={masterCellStyle}
                      onClick={this.handleStatusCellClick(device.address, device.status)}>
                      {Strings.MASTER_CLASS_2}
                    </Table.Cell>}>
                  <Popup.Content>
                    {this.getDeviceTooltip(device)}
                  </Popup.Content>
                </Popup>
              );
            }
          }
        }
      }
      else if (device.status === Constants.MASTER_FAULT) {
        if (device.lastEvent === null) {
          return (
            <Table.Cell
              selectable
              width={9}
              style={faultCellStyle}
              onClick={this.handleStatusCellClick(device.address, device.status)}>
              {Strings.MASTER_FAULT_STRING}
            </Table.Cell>
          );
        }
        else {
          if (this.state.devices[this.state.devices.length - 1].address === device.address) {
            return (
              <Popup position='left center' hoverable pinned
                trigger={
                  <Table.Cell
                    selectable
                    width={9}
                    style={faultCellStyle}
                    onClick={this.handleStatusCellClick(device.address, device.status)}>
                    {Strings.MASTER_FAULT_STRING}
                  </Table.Cell>}>
                <Popup.Content>
                  {this.getDeviceTooltip(device)}
                </Popup.Content>
              </Popup>
            );
          }
          else {
            return (
              <Popup position='bottom center' hoverable pinned
                trigger={
                  <Table.Cell
                    selectable
                    width={9}
                    style={faultCellStyle}
                    onClick={this.handleStatusCellClick(device.address, device.status)}>
                    {Strings.MASTER_FAULT_STRING}
                  </Table.Cell>}>
                <Popup.Content>
                  {this.getDeviceTooltip(device)}
                </Popup.Content>
              </Popup>
            );
          }
        }
      }
      else if (device.status === Constants.SLAVE_MASTER_FAULT) {
        if (device.lastEvent === null) {
          return (
            <Table.Cell
              selectable
              width={9}
              style={slaveMasterFaultCellStyle}
              onClick={this.handleStatusCellClick(device.address, device.status)}>
              {Strings.SLAVE_MASTER_FAULT_STRING}
            </Table.Cell>
          );
        }
        else {
          if (this.state.devices[this.state.devices.length - 1].address === device.address) {
            return (
              <Popup position='left center' hoverable pinned
                trigger={
                  <Table.Cell
                    selectable
                    width={9}
                    style={slaveMasterFaultCellStyle}
                    onClick={this.handleStatusCellClick(device.address, device.status)}>
                    {Strings.SLAVE_MASTER_FAULT_STRING}
                  </Table.Cell>}>
                <Popup.Content>
                  {this.getDeviceTooltip(device)}
                </Popup.Content>
              </Popup>
            );
          }
          else {
            return (
              <Popup position='bottom center' hoverable pinned
                trigger={
                  <Table.Cell
                    selectable
                    width={9}
                    style={slaveMasterFaultCellStyle}
                    onClick={this.handleStatusCellClick(device.address, device.status)}>
                    {Strings.SLAVE_MASTER_FAULT_STRING}
                  </Table.Cell>}>
                <Popup.Content>
                  {this.getDeviceTooltip(device)}
                </Popup.Content>
              </Popup>
            );
          }
        }
      }
      else if (device.status === Constants.MISSING) {
        if (device.lastEvent === null) {
          return (
            <Table.Cell
              selectable
              width={9}
              style={missingCellStyle}
              onClick={this.handleStatusCellClick(device.address, device.status)}>
              {Strings.MISSING_SINGULAR_STRING}
            </Table.Cell>
          );
        }
        else {
          if (this.state.devices[this.state.devices.length - 1].address === device.address) {
            return (
              <Popup position='left center' hoverable pinned
                trigger={
                  <Table.Cell
                    selectable
                    width={9}
                    style={missingCellStyle}
                    onClick={this.handleStatusCellClick(device.address, device.status)}>
                    {Strings.MISSING_SINGULAR_STRING}
                  </Table.Cell>}>
                <Popup.Content>
                  {this.getDeviceTooltip(device)}
                </Popup.Content>
              </Popup >
            );
          }
          else {
            return (
              <Popup position='bottom center' hoverable pinned
                trigger={
                  <Table.Cell
                    selectable
                    width={9}
                    style={missingCellStyle}
                    onClick={this.handleStatusCellClick(device.address, device.status)}>
                    {Strings.MISSING_SINGULAR_STRING}
                  </Table.Cell>}>
                <Popup.Content>
                  {this.getDeviceTooltip(device)}
                </Popup.Content>
              </Popup >
            );
          }
        }
      }
      else if (device.status === Constants.MPI) {
        if (device.lastEvent === null) {
          return (
            <Table.Cell
              selectable
              width={9}
              style={mpiCellStyle}
              onClick={this.handleStatusCellClick(device.address, device.status)}>
              {Strings.MPI_STRING}
            </Table.Cell>
          );
        }
        else {
          if (this.state.devices[this.state.devices.length - 1].address === device.address) {
            return (
              <Popup position='left center' hoverable pinned
                trigger={
                  <Table.Cell
                    selectable
                    width={9}
                    style={mpiCellStyle}
                    onClick={this.handleStatusCellClick(device.address, device.status)}>
                    {Strings.MPI_STRING}
                  </Table.Cell>}>
                <Popup.Content>
                  {this.getDeviceTooltip(device)}
                </Popup.Content>
              </Popup >
            );
          }
          else {
            return (
              <Popup position='bottom center' hoverable pinned
                trigger={
                  <Table.Cell
                    selectable
                    width={9}
                    style={mpiCellStyle}
                    onClick={this.handleStatusCellClick(device.address, device.status)}>
                    {Strings.MPI_STRING}
                  </Table.Cell>}>
                <Popup.Content>
                  {this.getDeviceTooltip(device)}
                </Popup.Content>
              </Popup >
            );
          }
        }
      }
      else if (device.status === Constants.MPI_FAULT) {
        if (device.lastEvent === null) {
          return (
            <Table.Cell
              selectable
              width={9}
              style={faultCellStyle}
              onClick={this.handleStatusCellClick(device.address, device.status)}>
              {Strings.MPI_STRING}
            </Table.Cell>
          );
        }
        else {
          if (this.state.devices[this.state.devices.length - 1].address === device.address) {
            return (
              <Popup position='left center' hoverable pinned
                trigger={
                  <Table.Cell
                    selectable
                    width={9}
                    style={faultCellStyle}
                    onClick={this.handleStatusCellClick(device.address, device.status)}>
                    {Strings.MPI_STRING}
                  </Table.Cell>}>
                <Popup.Content>
                  {this.getDeviceTooltip(device)}
                </Popup.Content>
              </Popup >
            );
          }
          else {
            return (
              <Popup position='bottom center' hoverable pinned
                trigger={
                  <Table.Cell
                    selectable
                    width={9}
                    style={faultCellStyle}
                    onClick={this.handleStatusCellClick(device.address, device.status)}>
                    {Strings.MPI_STRING}
                  </Table.Cell>}>
                <Popup.Content>
                  {this.getDeviceTooltip(device)}
                </Popup.Content>
              </Popup >
            );
          }
        }
      }
    }
  }

  createModelTableCell = (device) => {
    if (device.status === "master" || device.status === "masterFault" || device.status === "mpi" || device.status === "mpiFault") {
      return <Table.Cell width={8} verticalAlign="middle">-</Table.Cell>;
    }
    else {
      return < Table.Cell width={8} verticalAlign="middle">{device.model}</Table.Cell >;
    }
  }

  createDiagnosticsTableCell = (device) => {
    if (device.status === "master" || device.status === "masterFault" || device.status === "mpi" || device.status === "mpiFault") {
      return <Table.Cell width={6} verticalAlign="middle">-</Table.Cell>;
    }
    else {
      return < Table.Cell width={6} verticalAlign="middle">{device.diagnostics}</Table.Cell >;
    }
  }

  createRetriesNoFaultTableCell = (device) => {
    if (device.status === "master" || device.status === "masterFault" || device.status === "mpi" || device.status === "mpiFault") {
      return <Table.Cell width={6} verticalAlign="middle">-</Table.Cell>;
    }
    else {
      return < Table.Cell width={6} verticalAlign="middle">{device.retriesNoFault}</Table.Cell >;
    }
  }

  createRetriesTableCell = (device) => {
    if (device.status === "master" || device.status === "masterFault" || device.status === "mpi" || device.status === "mpiFault") {
      return <Table.Cell width={6} verticalAlign="middle">-</Table.Cell>;
    }
    else {
      return < Table.Cell width={6} verticalAlign="middle">{device.retries}</Table.Cell >;
    }
  }

  createFaultsTableCell = (device) => {
    if (device.status === "master" || device.status === "masterFault") {
      return <Table.Cell width={5} verticalAlign="middle">-</Table.Cell>;
    }
    else {
      return < Table.Cell width={5} verticalAlign="middle">{device.faults}</Table.Cell >;
    }
  }

  createWatchdogTableCell = (device) => {
    if (device.watchdog === null) {
      return <Table.Cell width={5} verticalAlign="middle">---</Table.Cell>;
    }
    else {
      if (device.watchdog) {
        return <Table.Cell width={5} verticalAlign="middle">{Strings.ACTIVE}</Table.Cell>;
      }
      else {
        return <Table.Cell width={5} verticalAlign="middle">{Strings.INACTIVE}</Table.Cell>;
      }
    }
  }

  /*
    Adjusts the size of the table so that it does not excced the
    browser window height limit
  */
  adjustTableMaxHeight = () => {
    const browserHeight = UtilsInstance.getBrowserWindowHeight();
    let newTableMaxHeight = browserHeight * Constants.SCALING_FACTOR_LIVE_TOPOLOGY;
    newTableMaxHeight = newTableMaxHeight.toString();
    newTableMaxHeight = newTableMaxHeight.concat("px");
    document.getElementById("main-table-container").style["maxHeight"] = newTableMaxHeight;
  }

  /*
    Saves the form input to the component state everytime the user
    types something in the form
  */
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  /*
    Remove offline or duplicate device from the live list
  */
  removeOfflineOrDuplicateDevice = (deviceMacAddress) => {
    let data = JSON.stringify({
      mac: deviceMacAddress
    });

    fetch(Constants.REQUEST_IP_ADDRESS + "remove_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.REMOVE_DEVICE_SUCCESS);
      })
      .catch((error) => {
        alert(Strings.REMOVE_DEVICE_FAILURE + Strings.REASON + error);
      });
  }

  getDeviceAvailability = (device) => {
    if (device.masterStatus !== null
      || (device.status === "master" && device.masterStatus === null)
      || device.status === "masterFault"
      || device.status === "mpi"
      || device.status === "mpiFault") {
      return "-";
    }
    else {
      for (let i = 0; i < this.state.maintenance.length; i++) {
        if (this.state.maintenance[i].address === device.address.toString()) {
          // The device availability is the percentage of time it was on "OK" status +
          // the percentage of time it was on "Alarme" status
          let availability = this.state.maintenance[i].percentageAvailable
            + this.state.maintenance[i].percentageDiagnostic;

          // Never let the availability be greater than 100%
          if (availability >= 100) {
            availability = 100;
          }

          return availability;
        }
      }
    }
  }

  getFormatedAvailability = (availability) => {
    if (availability !== null && availability !== undefined && availability !== "-") {
      const lang = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);
      let availabilityText = availability.toFixed(2);

      if (lang !== Constants.EN_LANG_KEY) {
        availabilityText = UtilsInstance.replacePointWithComma(availabilityText);
      }

      return availabilityText.concat("%");
    }
    else if (availability === "-") {
      return "-";
    }
  }

  getTagTextForCSV = (tag) => {
    if (tag === undefined || tag === null) {
      return " ";
    }
    else {
      return tag.replace(",", " ");
    }
  }

  getModelTextForCSV = (model) => {
    if (model === undefined || model === null) {
      return " ";
    }
    else {
      return model.replace(",", " ");
    }
  }

  getAvailabilityForCSV = (availability) => {
    if (availability === undefined || availability === null || typeof (availability) !== "number") {
      return "";
    }
    else {
      return availability.toFixed(2);
    }
  }

  getWatchdogForCSV = (device) => {
    if (device.watchdog === null) {
      return "---";
    }
    else {
      if (device.watchdog) {
        return Strings.ACTIVE;
      }
      else {
        return Strings.INACTIVE;
      }
    }
  }

  getStatusTextForCSV = (device) => {
    if (device.isInBlacklist) {
      return Strings.BLACKLIST_STRING;
    }
    else if (device.isInAutomaticBlacklist) {
      return Strings.CRITIC_SLAVE_STRING;
    }
    else {
      if (device.status === Constants.OK) {
        return Strings.OK_STRING;
      }
      else if (device.status === Constants.DIAGNOSTIC) {
        return Strings.DIAGNOSTIC_STRING;
      }
      else if (device.status === Constants.ONLINE) {
        return Strings.ONLINE_STRING;
      }
      else if (device.status === Constants.FAULT) {
        return Strings.FAULT_STRING;
      }
      else if (device.status === Constants.CONFIG_ERROR) {
        return Strings.CONFIG_ERROR_STRING;
      }
      else if (device.status === Constants.PARAM_ERROR) {
        return Strings.PARAM_ERROR_STRING;
      }
      else if (device.status === Constants.MASTER) {
        return Strings.MASTER_FAULT_STRING;
      }
      else if (device.status === Constants.MASTER_FAULT) {
        return Strings.SLAVE_MASTER_FAULT_STRING;
      }
      else if (device.status === Constants.SLAVE_MASTER_FAULT) {
        return Strings.SLAVE_MASTER_FAULT_STRING;
      }
      else if (device.status === Constants.MISSING) {
        return Strings.MISSING_SINGULAR_STRING;
      }
      else if (device.status === Constants.MPI) {
        return Strings.MPI_STRING;
      }
      else if (device.status === Constants.MPI_FAULT) {
        return Strings.MPI_CSV_FAULT_STRING;
      }
    }
  }

  getDiagnosticsForCSV = (device) => {
    if (device.status !== Constants.MASTER
      && device.status !== Constants.MASTER_FAULT
      && device.status !== Constants.MPI
      && device.status !== Constants.MPI_FAULT) {
      return device.diagnostics;
    }
    else {
      return "";
    }
  }

  getRetriesNoFaultForCSV = (device) => {
    if (device.status !== Constants.MASTER
      && device.status !== Constants.MASTER_FAULT
      && device.status !== Constants.MPI
      && device.status !== Constants.MPI_FAULT) {
      return device.retriesNoFault;
    }
    else {
      return "";
    }
  }

  getRetriesForCSV = (device) => {
    if (device.status !== Constants.MASTER
      && device.status !== Constants.MASTER_FAULT
      && device.status !== Constants.MPI
      && device.status !== Constants.MPI_FAULT) {
      return device.retries;
    }
    else {
      return "";
    }
  }

  getFaultsForCSV = (device) => {
    if (device.status !== Constants.MASTER && device.status !== Constants.MASTER_FAULT) {
      return device.faults;
    }
    else {
      return "";
    }
  }

  exportLiveListAsCSV = () => {
    let csvText = Strings.CSV_HEADER;

    for (let i = 0; i < this.state.devices.length; i++) {
      csvText += this.state.devices[i].address + ","
        + this.getTagTextForCSV(this.state.devices[i].tag) + ","
        + this.getModelTextForCSV(this.state.devices[i].model) + ","
        + this.getDiagnosticsForCSV(this.state.devices[i]) + ","
        + this.getRetriesNoFaultForCSV(this.state.devices[i]) + ","
        + this.getRetriesForCSV(this.state.devices[i]) + ","
        + this.getFaultsForCSV(this.state.devices[i]) + ","
        + this.getAvailabilityForCSV(this.state.devices[i].availability) + ","
        + this.getWatchdogForCSV(this.state.devices[i]) + ","
        + this.getStatusTextForCSV(this.state.devices[i]) + "\n";
    }

    const workbook = read(csvText, { type: "string", raw: true });
    /* Aqui convertemos o workbook para o formato .xlsx */
    const wbout = write(workbook, { bookType: "xlsx", type: "binary" });

    /* CriaÃ§Ã£o do blob e link para download */
    const blob = new Blob([UtilsInstance.s2ab(wbout)], { type: "application/octet-stream" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "Live List.xlsx";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    sessionStorage.removeItem("auth");
    this.retrieveData();
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.retrieveData, 5000) });
    this.adjustTableMaxHeight();
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalID);
  }

  componentDidUpdate() {
    this.adjustTableMaxHeight();
  }

  // Render the table containing all network devices
  render() {
    const column = this.state.column;
    const direction = this.state.sortDirection;
    const filter = this.state.formInput;

    const devices = this.state.devices.map(device => (
      <Table.Row key={device.address}>
        <Table.Cell width={4} verticalAlign="middle">{device.address}</Table.Cell>
        <Table.Cell width={8} verticalAlign="middle">{device.tag}</Table.Cell>
        {this.createModelTableCell(device)}
        {this.createDiagnosticsTableCell(device)}
        {this.createRetriesNoFaultTableCell(device)}
        {this.createRetriesTableCell(device)}
        {this.createFaultsTableCell(device)}
        <Table.Cell width={6} verticalAlign="middle">{this.getFormatedAvailability(device.availability)}</Table.Cell>
        {this.createWatchdogTableCell(device)}
        {this.createStatusCell(device)}
      </Table.Row>
    ));

    return (
      <div style={screenStyle}>

        <Grid columns="equal" textAlign="center" verticalAlign="middle">
          <Grid.Column>

          </Grid.Column>

          <Grid.Column>
            <Form style={searchStyle} onSubmit={this.handleSubmit} >
              <Form.Input
                id="inputform"
                placeholder={Strings.LIVE_LIST_INPUT_TEXT_PLACEHOLDER}
                icon="search"
                name="formInput"
                value={filter}
                onChange={this.handleChange} />
            </Form>
          </Grid.Column>

          <Grid.Column>
            <Segment id="legend-segment" basic textAlign="right">

              <Button
                content={Strings.EXPORT_CSV}
                color='teal'
                onClick={this.exportLiveListAsCSV} />

              <Popup position='bottom right' hoverable pinned
                trigger={<Icon name="question circle" size="big" color="teal" />}>
                <Popup.Content>
                  <p style={critSlaveExplTextStyle}>
                    <strong>{Strings.CRITIC_SLAVE_STRING}: </strong>
                    {Strings.CRITICAL_SLAVE_EXPLANATION}
                  </p>
                </Popup.Content>
              </Popup >

            </Segment>
          </Grid.Column>
        </Grid>

        <Table id="table-header" style={headerMarginStyle} sortable striped celled fixed singleLine selectable textAlign="center">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell
                width={4}
                sorted={column === "address" ? direction : null}
                onClick={this.handleSort("address")}>
                {Strings.ADDRESS}
              </Table.HeaderCell>

              <Table.HeaderCell
                width={8}
                sorted={column === "tag" ? direction : null}
                onClick={this.handleSort("tag")}>
                {Strings.TAG}
              </Table.HeaderCell>

              <Table.HeaderCell
                width={8}
                sorted={column === "model" ? direction : null}
                onClick={this.handleSort("model")}>
                {Strings.MODEL}
              </Table.HeaderCell>

              <Table.HeaderCell
                width={6}
                sorted={column === "diagnostics" ? direction : null}
                onClick={this.handleSort("diagnostics")}>
                {Strings.DIAGNOSTICS_STRING}

                <Popup position='top center' hoverable pinned
                  trigger={<Icon style={critSlaveExpPopupStyle} name="question circle" color="teal" />}>
                  <Popup.Content>
                    <p style={critSlaveExplTextStyle}>{Strings.DIAGNOSTICS_QUESTION_INFO}</p>
                  </Popup.Content>
                </Popup >

              </Table.HeaderCell>

              <Table.HeaderCell
                width={6}
                sorted={column === "retriesNoFault" ? direction : null}
                onClick={this.handleSort("retriesNoFault")}>
                {Strings.RETRIES_STRING}
                <br />
                {Strings.NO_FAULTS_STRING}
                <Popup position='top center' hoverable pinned
                  trigger={<Icon style={critSlaveExpPopupStyle} name="question circle" color="teal" />}>
                  <Popup.Content>
                    <p style={critSlaveExplTextStyle}>{Strings.NOT_RETRIES_QUESTION_INFO}</p>
                  </Popup.Content>
                </Popup >
              </Table.HeaderCell>

              <Table.HeaderCell
                width={6}
                sorted={column === "retries" ? direction : null}
                onClick={this.handleSort("retries")}>
                {Strings.RETRIES_STRING}
                <br />
                {Strings.TOTAL}
                <Popup position='top center' hoverable pinned
                  trigger={<Icon style={critSlaveExpPopupStyle} name="question circle" color="teal" />}>
                  <Popup.Content>
                    <p style={critSlaveExplTextStyle}>{Strings.RETRIES_QUESTION_INFO}</p>
                  </Popup.Content>
                </Popup >
              </Table.HeaderCell>

              <Table.HeaderCell
                width={5}
                sorted={column === "faults" ? direction : null}
                onClick={this.handleSort("faults")}>
                {Strings.FAULTS_STRING}

                <Popup position='top center' hoverable pinned
                  trigger={<Icon style={critSlaveExpPopupStyle} name="question circle" color="teal" />}>
                  <Popup.Content>
                    <p style={critSlaveExplTextStyle}>{Strings.FAULTS_QUESTION_INFO}</p>
                  </Popup.Content>
                </Popup >

              </Table.HeaderCell>

              <Table.HeaderCell
                width={6}
                sorted={column === "availability" ? direction : null}
                onClick={this.handleSort("availability")}>
                {Strings.AVAILABILITY}
              </Table.HeaderCell>

              <Table.HeaderCell
                width={5}
                disabled>
                {Strings.WATCHDOG_STRING}
                <Popup position='bottom center' hoverable pinned wide
                  trigger={<Icon style={critSlaveExpPopupStyle} name="question circle" color="teal" />}>
                  <Popup.Content>
                    <p style={critSlaveExplTextStyle}>
                      {Strings.WATCHDOG_QUESTION_INFO}
                    </p>
                  </Popup.Content>
                </Popup >

              </Table.HeaderCell>

              <Table.HeaderCell
                width={9}
                sorted={column === "status" ? direction : null}
                onClick={this.handleSort("status")}>
                {Strings.STATUS}
              </Table.HeaderCell>

            </Table.Row>
          </Table.Header>
        </Table>

        <div id="main-table-container" style={tableStyle}>
          <Table id="main-table" sortable striped celled fixed selectable textAlign="center" columns={7}>
            <Table.Body>{devices}</Table.Body>
          </Table>

        </div>
      </div>
    );
  }
}

// CSS custom table stylization
const screenStyle = {
  marginTop: "8px",
  marginLeft: "4px",
  marginRight: "4px",
  marginBottom: "8px",
  textAlign: "center",
};

const tableStyle = {
  overflowY: "scroll"
};

const headerMarginStyle = {
  marginTop: "0px",
  marginBottom: "8px",
  width: "99.5%"
};

const okCellStyle = {
  color: "black",
  backgroundColor: "lime",
  verticalAlign: "middle"
};

const diagnosticCellStyle = {
  color: "black",
  backgroundColor: "yellow",
  verticalAlign: "middle"
};

const onlineCellStyle = {
  color: "black",
  backgroundColor: "lightBlue",
  verticalAlign: "middle"
};

const faultCellStyle = {
  color: "black",
  backgroundColor: "red",
  verticalAlign: "middle"
};

const configErrorCellStyle = {
  color: "black",
  backgroundColor: "LightPink",
  verticalAlign: "middle"
};

const paramErrorCellStyle = {
  color: "white",
  backgroundColor: "MediumVioletRed",
  verticalAlign: "middle"
};

const masterCellStyle = {
  color: "black",
  backgroundColor: "white",
  verticalAlign: "middle"
};

const mpiCellStyle = {
  color: "white",
  backgroundColor: "#000080",
  verticalAlign: "middle"
};

const blacklistCellStyle = {
  color: "white",
  backgroundColor: "black",
  verticalAlign: "middle"
};

const criticSlaveCellStyle = {
  color: "white",
  backgroundColor: "darkRed",
  verticalAlign: "middle"
};

const slaveMasterFaultCellStyle = {
  color: "white",
  backgroundColor: "#B22222",
  verticalAlign: "middle"
};

const missingCellStyle = {
  color: "white",
  backgroundColor: "#708090",
  verticalAlign: "middle"
};

const searchStyle = {
  marginBottom: "2vh"
};

const mapActionsToProps = {
  onChangeLog: logAction
};

const critSlaveExplTextStyle = {
  textAlign: "left"
};

const critSlaveExpPopupStyle = {
  marginLeft: "4px"
};

export default connect(null, mapActionsToProps)(withRouter(LiveList));
